'use strict';

const Http = require('../http');
const UniteBasketItem = require('./UniteBasketItem');

class UniteBasketUpdate {

    constructor(basketId, basketFormHdi) {
        this.basketId = basketId;
        this.basketFormHdi = basketFormHdi;
        this.basketItemList = [];
    }

    add(basketItemId, tabName, ociProdId, feeGrpId, oldQuantityHid, newQuantityHid) {
        if (UniteBasketItem.isUniteProduct(tabName) || UniteBasketItem.isUniteShipping(tabName)) {
            const item = new UniteBasketItem(basketItemId, tabName);
            item.setQuantityOld(oldQuantityHid);
            item.setQuantityNew(newQuantityHid, tabName);
            item.setUniteArticleId(ociProdId);
            item.setCustomerArticleNumber(tabName, feeGrpId);

            this.basketItemList.push(item);
        }
    }

    send() {
        const self = this;

        if (this.basketId && this.basketItemList.length) {
            this.setLoadingTo(true);
            const url = `${sessionStorage.getItem(window.STORAGE_KEY.API_URL)}/unite/basket/${this.basketId}`;

            // Der request aktualisiert und synchronisiert den Unite Warenkorb
            Http.put(url, JSON.stringify(this.basketItemList)).then(() => {
                this.setLoadingTo(false);
                self.sendBasketForm()
            }, (error) => {
                this.setLoadingTo(false);
                console.error('UniteBasketUpdateError', error);
            })
        } else {
            // Die Liste von Unite Artikeln ist leer. Nur die Form absenden
            this.sendBasketForm();
        }
    }

    setLoadingTo(isLoading) {
        if(isLoading) {
            document.getElementById('refreshLoading').setAttribute('class', '');
            document.getElementById('refreshNotLoading').setAttribute('class', 'd-none');
        } else {
            document.getElementById('refreshLoading').setAttribute('class', 'd-none');
            document.getElementById('refreshNotLoading').setAttribute('class', '');
        }
    }

    sendBasketForm() {
        window.sendForm(this.basketFormHdi);
    }

}

window.UniteBasketUpdate = UniteBasketUpdate;
